var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInventoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7002 6.30005C13.5404 6.30005 12.6002 7.24025 12.6002 8.40005C12.6002 9.55985 13.5404 10.5 14.7002 10.5H27.3002C28.46 10.5 29.4002 9.55985 29.4002 8.40005C29.4002 7.24025 28.46 6.30005 27.3002 6.30005H14.7002Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4002 14.7C8.4002 13.5403 9.3404 12.6 10.5002 12.6H31.5002C32.66 12.6 33.6002 13.5403 33.6002 14.7C33.6002 15.8598 32.66 16.8 31.5002 16.8H10.5002C9.3404 16.8 8.4002 15.8598 8.4002 14.7Z",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2002 23.1C4.2002 20.7805 6.0806 18.9 8.4002 18.9H33.6002C35.9198 18.9 37.8002 20.7805 37.8002 23.1V31.5001C37.8002 33.8196 35.9198 35.7001 33.6002 35.7001H8.4002C6.0806 35.7001 4.2002 33.8196 4.2002 31.5001V23.1Z",
    fill: "#707070"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventoryIcon.7804a25f.svg";
export { ForwardRef as ReactComponent };